<template>
  <a-spin :spinning="boxSpinning">
    <div id="steps-first">
      <h1>基本信息</h1>
      <a-form-model ref="firstForm" :labelCol="{ span: 8 }" :wrapperCol="{ span: 10 }" :model="firstForm.data"
                    :rules="firstForm.rules">
        <a-form-model-item label="报告类型" prop="reportType">
          <a-select :disabled="firstForm.reportTypeDisabled"
                    v-model="firstForm.data.reportType" placeholder="请选择报告类型">
            <a-select-option :value="1">单校团体训练报告</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="报告名称" prop="name">
          <a-input v-model.trim="firstForm.data.name" :maxLength="35" placeholder="不超过35个字符">
              <span class="input-number" slot="suffix">
                {{ firstForm.data.name ? firstForm.data.name.length : 0 }} / 35
              </span>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="期望进度" prop="expectedProgress"
                           help="期望进度指截止报告生成的日期，预期达成的课程进度">
          <a-input-number v-model="firstForm.data.expectedProgress" :min="1" :max="100" :precision="0"
                          placeholder="1 - 100" />
          %
        </a-form-model-item>

        <a-form-model-item label="报告日期" prop="reportDate">
          <a-date-picker placeholder="请选择日期" v-model="firstForm.data.reportDate"
                         format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
        </a-form-model-item>

        <a-form-model-item :wrapper-col="{ span: 10, offset: 8 }" style="text-align: right">
          <a-button @click="cancel" style="margin-right: 20px">取消</a-button>
          <a-button type="primary" @click="onSubmit">下一步</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-spin>
</template>

<script>
import { FormatDate } from "@/pages/projectImpl/js/utils";
import moment from "moment";

export default {
  name: "StepsFirst",
  data() {
    return {
      moment,
      boxSpinning: false,
      firstForm: {
        reportTypeDisabled: false,
        data: {
          id: undefined,
          expectedProgress: undefined,
          name: undefined,
          reportDate: FormatDate(Date.now(), "YYYY-MM-DD"),
          reportType: 1,
        },
        rules: {
          name: [
            { required: true, message: "请输入报告名称", trigger: "blur" },
            { min: 2, max: 35, message: "报告名称长度为 2 到 35个字符", trigger: "blur" },
            {
              validator: (_, value, callback) => {
                const reg = /^[a-zA-Z0-9\u4e00-\u9fa5()（）_]+$/;
                if (!reg.test(value)) {
                  callback(new Error("报告名称不能包含特殊字符"));
                } else {
                  callback();
                }
              },
              trigger: "blur",
            },
          ],
          expectedProgress: [{ required: true, message: "请输入期望进度", trigger: "change" }],
          reportDate: [{ required: true, message: "请选择日期", trigger: "change" }],
          reportType: [{ required: true, message: "请选择报告类型", trigger: "change" }],
        },
      },
    };
  },
  mounted() {
    this.trainReportDetails();
  },
  methods: {
    //下一步
    onSubmit() {
      this.$refs["firstForm"].validate((valid) => {
        if (valid) {
          const Params = {
            "id": this.firstForm.data.id,
            "reportType": this.firstForm.data.reportType,
            "name": this.firstForm.data.name,
            "reportDate": this.firstForm.data.reportDate,
            "expectedProgress": this.firstForm.data.expectedProgress,
          };
          let request = this.$http.ReportService.GroupTrainingReportPost;
          if (Params.id) {
            request = this.$http.ReportService.GroupTrainingReportPut;
          }
          this.boxSpinning = true;
          request(Params).then(res => {
            if (res.data) {
              Params.id = res.data;
            }
            this.$store.commit("organization/setReportInfo", Params);
            this.$parent.$data.current = 1;
          }).finally(() => {
            this.boxSpinning = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 训练报告详情
    trainReportDetails() {
      if (!this.$store.getters["organization/getReportInfo"].id) {
        return;
      }
      this.boxSpinning = true;
      this.$http.ReportService.GroupTrainingReportDetails(this.$store.getters["organization/getReportInfo"].id).then(res => {
        for (let dataKey in this.firstForm.data) {
          if (typeof res.data[dataKey] !== "undefined") {
            this.firstForm.data[dataKey] = res.data[dataKey];
          }
        }
      }).finally(() => {
        this.boxSpinning = false;
      });
    },
    cancel() {
      this.$bus.$emit("closeCreateReport");
    },
  },
};
</script>

<style lang="less" scoped>
#steps-first {
  h1 {
    font-size: 20px;
    color: #333;
    margin-bottom: 30px;
  }

  .projectContent {
    padding: 16px;
    border-radius: 8px;
    border: 1px solid #ccc8c8;

    ::v-deep .ant-checkbox-group {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
  }
}

.input-number {
  font-size: 13px;
  color: #bbb;
}
</style>
